import { useTranslation } from "@msuite/ui/localization";
import type { CrewDefinitionListItem } from "@/hooks/use-crew-definitions";
import { CapacityCalendarRowWrapper } from "../capacity-calendar";
import { CapacityPlannerManagerSlotRow } from "./capacity-planner-manager-slot-row";

/** Props Interface */
interface CapacityPlannerManagerSlotRowsProps {
	crewDefinition: CrewDefinitionListItem;
}

/**
 * The manager windows under an opened crew, one row each.
 *
 * They come off the crew the list already carries rather than a read of their own: the crew row
 * above draws a coverage strip from the same windows whether or not it is open, so fetching them
 * per crew as it opens would ask twice for what one query already answered.
 */
export function CapacityPlannerManagerSlotRows({
	crewDefinition,
}: CapacityPlannerManagerSlotRowsProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!crewDefinition._managerSlots.length) {
		return (
			<CapacityCalendarRowWrapper variant="sub">
				<div className="min-w-0 col-span-full">
					<p className="label truncate">{t("planning.crews.no_manager_slots")}</p>
				</div>
			</CapacityCalendarRowWrapper>
		);
	}

	/** Render */
	return crewDefinition._managerSlots.map((managerSlot) => (
		<CapacityPlannerManagerSlotRow
			key={managerSlot.id}
			crewDefinition={crewDefinition}
			managerSlot={managerSlot}
		/>
	));
}
